module.exports = __webpack_public_path__ + "86a44c1afd694c33499017fab7eb2879.png";